const md5 = require("md5");

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString(); // Format based on the user's locale
};

export const convertFromSnake = (text) => {
  return text
    .replace(/_/g, " ") // Replace underscores with spaces
    .split(" ") // Split the string into an array of words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(" ");
};

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const md5Password = (password) => {
  return md5(password);
};
